import { render, staticRenderFns } from "./SearchCompanyUser.vue?vue&type=template&id=87aef856&"
import script from "./SearchCompanyUser.vue?vue&type=script&lang=js&"
export * from "./SearchCompanyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports